import { stripePromise } from '@/services/billing';
import { Elements } from '@stripe/react-stripe-js';
import { StripeElementsOptions } from '@stripe/stripe-js';
import PaymentForm, { PaymentFormProps } from './PaymentForm';

export default function PaymentFormContainer(props: PaymentFormProps) {
    const options: StripeElementsOptions = {
        mode: 'subscription',
        amount: 0, // no charge for free trial
        currency: 'usd',
        payment_method_types: ['card'],
        appearance: {
            theme: 'stripe',
            variables: {
                fontFamily: 'Inter',
                borderRadius: '6px',
            },
        },
        fonts: [
            {
                cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&&display=swap',
            },
        ],
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <PaymentForm {...props} />
        </Elements>
    );
}
